function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M53 24.4c-6.9 6.2-11.1 14.9-11.8 24.2l-.6 8.4c-.7 9.6-5.2 18.5-12.5 24.7l-11.3 9.7L35.4 113l20.3-17.5c7.2-6.2 11.7-15.1 12.4-24.6l.7-9c.7-9.3 4.9-17.9 11.8-24.1l16.3-14.7L77.9 2 53 24.4zM49.7 127.6h233.8v71H49.7v-71zM255 156.1H78.2v14H255v-14zM0 127.6h28.5v70.9H0z"
})));